import { ReactQuery } from '@codeleap/common'
import { queryClient } from './queryClient'
import { api } from '@/app'

export const profanityWordsKey = queryClient.queryKey<string[]>(['profanityWords'])

export async function retrieveProfanityWords() {

  const response = await api.get<string[]>('adm/profanity_words/')

  return response.data
}

export const useProfanityWords = () => {
  const options = ReactQuery.useQuery({
    queryKey: profanityWordsKey.key,
    queryFn: retrieveProfanityWords,

  })
  return options
}

export function prefetchProfanityWords() {
  queryClient.client.ensureQueryData({
    queryKey: profanityWordsKey.key,
    queryFn: retrieveProfanityWords,
  })

}
